/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Defaultlocation_Zipcode_Placeholder2Inputs */

const en__field_defaultlocation_zipcode_placeholder2 = /** @type {(inputs: _Field_Defaultlocation_Zipcode_Placeholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zip Code`)
};

/**
* | output |
* | --- |
* | "Zip Code" |
*
* @param {_Field_Defaultlocation_Zipcode_Placeholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const _field_defaultlocation_zipcode_placeholder2 = /** @type {((inputs?: _Field_Defaultlocation_Zipcode_Placeholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Defaultlocation_Zipcode_Placeholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en__field_defaultlocation_zipcode_placeholder2(inputs)
});
export { _field_defaultlocation_zipcode_placeholder2 as "_field_defaultLocation_zipCode_placeholder" }